import {Grid} from '@logistics-frontend/blocks'
import {useMediaQuery} from '@logistics-frontend/blocks/legacy'
import {breakpoints} from '@logistics-frontend/blocks/theme/theme'
import React from 'react'

import {PaymentCard} from '../payment-card'
import {PaymentCardListProps as Props} from './PaymentCardList.types'

export function PaymentCardList({mobile, selectedCard, cards, children, onSelectCard}: Props): React.ReactElement {
  const isMobile = useMediaQuery(breakpoints.down('sm'))

  return (
    <Grid size="m" container>
      {cards.map(card => (
        <Grid key={card.id} md={6} xs={12} item>
          <PaymentCard
            card={card}
            isChecked={card.id === selectedCard?.id}
            isMobile={mobile === undefined ? isMobile : mobile}
            onPress={onSelectCard}
          />
        </Grid>
      ))}
      {children && (
        <Grid md={6} xs={12} item>
          {children}
        </Grid>
      )}
    </Grid>
  )
}

export default React.memo(PaymentCardList)
